import React from "react";
import SocialBroadcastView from "../superadmin/socialBroadcast";

/**
 * Admin / Staff Social Media Broadcast Console.
 * Allows staff admins to compose multi-platform broadcasts and inspect audit logs.
 */
const AdminSocialBroadcast: React.FC = () => {
  return <SocialBroadcastView isSuperAdmin={false} />;
};

export default AdminSocialBroadcast;
